module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图08-2.jpg?v=669b9d9b";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图08-2.jpg
 ** module id = 53
 ** module chunks = 1 2
 **/